import { module } from 'angular';

import { default as domainListName, DomainList } from './domain-list.component.ajs';

export default module('hypervision.synthetic-view.domain-list', []).component(domainListName, new DomainList()).name;
